module.exports = __webpack_public_path__ + "img/img12.6550ef2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img12.jpg
// module id = 308
// module chunks = 0